import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material"
import apiMcu from "api/mcu";
import { TooltipCC } from "components/common";
import { IconDeleteUser, IconEditUser } from "components/common/IconCommon";
import { DIALOG_ID } from "components/Dialog/constant";
import NotFoundData from "components/NotFound";
import { PaginationButtons, TableHeaderCC } from "components/Table";
import { headCellsDeviceList } from "components/Table/Functions";
import { IconViewDetail } from "pages/service-package-management/assets";
import { useDispatch } from "react-redux";
import { setDetailDevice, setIsDetailed } from "store/mcuSlice";
import { transHeadCells } from "utils/functions";
import { getIndexCellTable, setCloseDialogCC, setOpenDialogCC, toastError, toastSuccess } from "utils/helpers";

export const DeviceList = ({
    sizeRow,
    dataLake,
    t,
    setReload,
    handleOpenDialogDelete,
    currentPage,
    handleChangePage,
    isLargePC,
    navigate,
}) => {
    const dispatch = useDispatch();

    const apiDeleteDevice = (id) => {
        return apiMcu.deleteDevice(id);
    }

    const handleDeleteDevice = (id, name) => {
        const content = <div>
            {t('mcu.dialog.content.deleteDevice')} <span style={{ fontWeight: 700 }}>{name}</span>?
        </div>
        setOpenDialogCC({
            id: DIALOG_ID.CONFIRM,
            props: {
                title: t("mcu.dialog.title.deleteDevice"),
                contentText: content,
                isDisableLoadingButton: true,
                cancel: t('mcu.dialog.action.cancel'),
                action: t('mcu.dialog.action.deleteDevice'),
                onClick: () => {
                    apiDeleteDevice(id)
                        .then(result => {
                            toastSuccess(t('mcu.toast.deleteDeviceSuccessfully'))
                        })
                        .catch(error => {
                            toastError(t('mcu.toast.error'))
                        })
                        .finally(() => {
                            setCloseDialogCC()
                            setReload(prev => !prev)
                        })
                }
            }
        })
    }

    return (
        <Box>
            <TableContainer
                sx={{
                    overflowX: 'initial',
                    overflowY: 'auto',
                    height: isLargePC || window.innerHeight > 800 ? 'auto' : 'auto',
                }}
            >
                <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={sizeRow}>
                    <TableHeaderCC headCellTable={transHeadCells(headCellsDeviceList, t)} styleHeadCell={{ boxShadow: 'none !important', borderBottom: '1px solid rgb(209, 209, 209) !important' }} />
                    <TableBody>
                        {dataLake?.data && dataLake?.data.map((data, index) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={data.id} sx={{ cursor: 'auto' }}>
                                    <TableCell align="center">{getIndexCellTable(currentPage, 5, index)}</TableCell>
                                    <TableCell sx={{ width: '155px', overflowWrap: 'anywhere' }}>{data.code}</TableCell>
                                    <TableCell sx={{ width: '215px', overflowWrap: 'anywhere' }}>{data.name}</TableCell>
                                    <TableCell sx={{ width: '109px', overflowWrap: 'anywhere' }}>{data.vendor}</TableCell>
                                    <TableCell sx={{ width: '155px', overflowWrap: 'anywhere' }}>{data.model}</TableCell>
                                    <TableCell sx={{ width: '155px', overflowWrap: 'anywhere' }}>{data.serial_number}</TableCell>
                                    <TableCell sx={{ width: '155px', overflowWrap: 'anywhere' }}>{data.preferred_room_number}</TableCell>
                                    <TableCell sx={{ width: '155px', overflowWrap: 'anywhere' }}>{data.sip_account}</TableCell>
                                    <TableCell sx={{ width: '155px', overflowWrap: 'anywhere' }}>{data.mgmt_ip}</TableCell>
                                    <TableCell sx={{ width: '155px', overflowWrap: 'anywhere' }}>{data.mgmt_port}</TableCell>
                                    <TableCell sx={{ width: '155px', textDecoration: 'underline', color: '#0054D1' }}>{data.mgmt_url}</TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <TooltipCC title={t('mcu.tooltip.viewDetail')}>
                                                <IconButton 
                                                    onClick={() => {
                                                        dispatch(setIsDetailed(true));
                                                        dispatch(setDetailDevice(data));
                                                    }} 
                                                    size={sizeRow}
                                                >
                                                    <IconViewDetail />
                                                </IconButton>
                                            </TooltipCC>
                                            <TooltipCC title={t('mcu.tooltip.edit')}>
                                                <IconButton
                                                    onClick={() => {
                                                        setOpenDialogCC({
                                                            id: DIALOG_ID.CREATE_OR_UPDATE_MCU_DEVICE,
                                                            props: {
                                                                title: t('mcu.dialog.title.editDevice'),
                                                                titleButtonAction: t('mcu.dialog.action.editRoom'),
                                                                titleButtonCancel: t('mcu.dialog.action.cancel'),
                                                                data: {
                                                                    name: data?.name,
                                                                    code: data?.code,
                                                                    brand: data?.vendor,
                                                                    model: data?.model,
                                                                    serial: data?.serial_number,
                                                                    room: data?.preferred_room_id,
                                                                    sip: data?.sip_account_id,
                                                                    ip: data?.mgmt_ip,
                                                                    port: data?.mgmt_port,
                                                                    link: data?.mgmt_url,
                                                                    nameRoom: data?.preferred_room_name,
                                                                    nameSip: data?.sip_account?.split('@')[0],
                                                                    id: data?.id
                                                                },
                                                                agreeAction: () => {
                                                                    setReload((prev) => !prev);
                                                                    setCloseDialogCC();
                                                                },
                                                            },
                                                        });
                                                    }}
                                                    size={sizeRow}
                                                >
                                                    <IconEditUser />
                                                </IconButton>
                                            </TooltipCC>
                                            <TooltipCC title={t('mcu.tooltip.delete')}>
                                                <IconButton onClick={() => { handleDeleteDevice(data?.id, data?.name) }} size={sizeRow}>
                                                    <IconDeleteUser />
                                                </IconButton>
                                            </TooltipCC>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {dataLake.totalElements ? <PaginationButtons page={currentPage} handleChangePage={handleChangePage} limit={5} total={dataLake.totalElements} /> : <></>}
            {dataLake.totalElements === 0 && <NotFoundData />}
        </Box>
    )
}
